module.exports = __webpack_public_path__ + "23_bigdata_1.jpg?4b9a592cf26d9a4ecb3cefb96325915f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_bigdata_1.jpg
// module id = 192
// module chunks = 0